import i18n from '@/i18n';

/**
 * Builds the option list of an enum-backed select.
 *
 * Entries retired from the business vocabulary carry `deprecated: true`: they are
 * hidden from new selections but stay available when a record still carries one, so
 * historical samples keep showing their label instead of the raw key.
 *
 * Options are ordered by the translated label rather than by the key. The order
 * therefore follows the language the customer picked, which is what they read.
 */
export function enumOptions(list, prefix, currentValue = null) {
  return list
    .filter(item => !item.deprecated || item.value === currentValue)
    .map(item => ({ label: `${prefix}.${item.value}`, value: item.value }))
    .sort((a, b) => i18n.t(a.label).localeCompare(i18n.t(b.label), i18n.locale));
}

export default enumOptions;
